var Cube = require('cube-js')
string = require('sprintf-js');

var app = function(conf) {
  this.container = conf.container;
  this.wrap = this.container.find('.scene-list');
  this.scene_list = this.container.find('.scene');

  this.init();
};

Cube.mix(app.prototype, {

  is_fixed: 0,

  wrap: null,
  container: null,
  scene_list: null,

  wide_enough: false,

  top: 0,

  bottom: 0,

  window_width: 0,

  window_height: 0,

  init: function() {
    this.scene_list.size();
  },

  updateSize: function(window_width, window_height) {

    this.window_width = window_width;
    this.window_height = window_height;

    this.wide_enough = window_width >= 1080 ? 1 : 0;

    this.scene_list.css({
      width: window_width,
      height: window_height,
    });

    if (!this.wide_enough) {
      this.wrap.removeClass("fixed pass");
      this.container.find(".slide").fadeIn();
      this.is_fixed = 0;
      var height = 1040 / 1920 * window_width;
      this.scene_list.css("height", height);
    }

    this.top = this.container.offset().top;
    this.bottom = this.top + this.container.height();
  },

  onScroll: function(scrool_top, scrool_bottom) {

    var offset = 80;

    if (!this.wide_enough) {
      return;
    }

    var cross_top = scrool_top > this.top - offset;
    var cross_bottom = scrool_bottom >= (this.bottom - offset);

    if (!this.is_fixed && cross_top && !cross_bottom) {
      this.wrap.removeClass('pass').addClass("fixed");
      this.is_fixed = 1;
    } else {
      if (this.is_fixed && scrool_top < this.top - offset) {
        this.wrap.removeClass('pass fixed');
        this.is_fixed = 0;
      } else {
        if (this.is_fixed && cross_bottom) {
          this.wrap.removeClass('fixed').addClass("pass");
          this.is_fixed = 0;
        }
      }

      var that = this;
      this.scene_list.each(function(index) {

        var item = $(this);
        var _b = scrool_top + that.window_height / 1.5 > item.offset().top;

        if (index > 0 && _b) {
          item.find("b").fadeIn();
        } else {
          if (index > 0 && !_b) {
            item.find("b").fadeOut();
          }
        }
      })
    }
  },
});

module.exports = app;



//////////////////
// WEBPACK FOOTER
// ./src/js/home/fixed_scene.js
// module id = 47
// module chunks = 2 3